var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0429 2.32913e-05C17.1288 0.0123482 22.0122 4.92998 22 11.0555C21.9877 17.144 17.0675 22.0123 10.9325 22C4.85891 21.9877 -0.0122468 17.0454 2.3129e-05 10.9076C0.012293 4.86836 4.9448 -0.0123016 11.0429 2.32913e-05ZM13.8528 19.3748C14.6994 19.1159 15.5828 18.9311 16.4049 18.5983C17.1902 18.2779 17.2883 17.7725 16.8221 17.07C16.3926 16.4291 15.9264 15.7882 15.4356 15.1966C14.319 13.8409 14.2822 13.8532 13.0184 15.0241C12.3926 15.6034 12.135 15.6034 11.5337 14.9748C10.0245 13.3972 8.95706 11.5361 8.2454 9.47787C7.79142 8.17144 7.87731 8.04819 9.17792 7.65379C9.30062 7.61681 9.41105 7.59216 9.53374 7.54286C10.2209 7.30869 10.3926 7.03754 10.1472 6.33502C9.77914 5.36136 9.38651 4.40001 8.95706 3.451C8.6135 2.69918 8.12271 2.55128 7.42332 3.01962C5.88958 4.05492 4.93253 5.43531 4.90799 7.34567C4.88345 8.71373 5.3129 9.97087 5.85277 11.191C6.92025 13.6067 8.23314 15.8622 10.1718 17.6986C11.1902 18.6723 12.3804 19.2515 13.8528 19.3748Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.37474290bf480445cda99fbcba286d68.svg";
export { ForwardRef as ReactComponent };